export default __webpack_public_path__ + "static/media/profile-user.f281d2a1.svg";